<template>
  <router-view :key="$route.fullPath" />
  <Toasts />
  <CollabStatusBanner />
  <div class="mt-3 pb-5" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Toasts from '@app/components/generic/toasts.vue';
import CollabStatusBanner from '@app/components/generic/collabStatusBanner.vue';
import store from '@app/store';

export default defineComponent({
  components: {
    Toasts,
    CollabStatusBanner,
  },
  data: function() {
    return {
      beforeUnloadHandler: null as null | ((event: BeforeUnloadEvent) => void),
    };
  },
  mounted: function() {
    this.beforeUnloadHandler = (event: BeforeUnloadEvent) => {
      const hasUnsynced = Object.values(store.state.collabConnections)
        .some((entry) => entry.hasUnsyncedChanges);
      if (hasUnsynced) {
        event.preventDefault();
        // Required for some browsers (Chrome) to actually show the prompt.
        event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },
  beforeUnmount: function() {
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
      this.beforeUnloadHandler = null;
    }
  },
});

</script>
